import React from "react";
import styles from "./ExternalLink.module.css";

// This is a component to build a external link to open in a new window
const ExternalLink = ({ link, children, clickHandler }) => {
  return (
    <a
      className={styles.link}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      onClick={clickHandler}
    >
      {children}
    </a>
  );
};

export default ExternalLink;
